import * as z from 'zod';
import { familyIdSchema, userIdSchema } from '../primitives/id.js';
import { instantSchema, timeZoneSchema } from '../primitives/time.js';
/**
 * Only `FAMILY_OWNER` is issued today.
 *
 * The rest exist because SPEC.md §32 requires the model to keep role-based
 * permissions possible. Adding a role later must not mean revisiting every
 * authorisation check.
 */
export const familyRoleSchema = z.enum(['FAMILY_OWNER', 'PARENT', 'CAREGIVER', 'READ_ONLY']);
export const familySchema = z.object({
    id: familyIdSchema,
    name: z.string().min(1).max(80),
    /**
     * Required, not optional.
     *
     * SPEC.md §19.2: the daily budget's day has to start somewhere, and it has to
     * keep starting in the same place when a device travels.
     */
    timeZone: timeZoneSchema,
    createdAt: instantSchema,
});
export const familyMemberSchema = z.object({
    userId: userIdSchema,
    familyId: familyIdSchema,
    role: familyRoleSchema,
    displayName: z.string().min(1).max(80),
    email: z.email(),
});
//# sourceMappingURL=family.js.map